import { setApi } from './index'
const paths = {
  guideList: '/guideline/searchEs',
  searchGuideList: '/guideline/search',
  searchEsGuideList: 'guideline/searchEs',
  guideKsList: '/guideline/getKeshi',
  guideDetails: '/guideline/getGuidelineByIdNew',
  guidePutDownRead: 'guideline/putDownRead',
  guidDownloadList: 'guideline/getRecordsList',
  guidelineByIdCheck: '/guideline/getGuidelineByIdCheck',
  getYears: '/guideline/getYears',
  getCategoryList: '/guideline/getCategoryList',
  getKeshiDis: '/guideline/getKeshiDis'
}

const guide = setApi(paths)
export default guide
